/**
 * Frontend Sentry initialization — DORMANT until REACT_APP_SENTRY_DSN_FRONTEND is set.
 *
 * Reserved env vars (frontend/.env):
 *   REACT_APP_SENTRY_DSN_FRONTEND     full Sentry DSN for the React project
 *   REACT_APP_ENV                      preview | production (defaults to "preview")
 *   REACT_APP_RELEASE                  release identifier (git sha or semver)
 *
 * Privacy-first: send_default_pii=false; beforeSend strips request bodies +
 * query strings + Authorization headers + user objects except {id}.
 */
import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN_FRONTEND;
const ENV = process.env.REACT_APP_ENV || 'preview';
const RELEASE = process.env.REACT_APP_RELEASE || 'shs-frontend-dev';

function beforeSend(event) {
  try {
    if (event.request) {
      if (event.request.data) event.request.data = '[REDACTED]';
      if (event.request.query_string) event.request.query_string = '';
      const headers = event.request.headers || {};
      const SENSITIVE = ['authorization', 'cookie', 'set-cookie', 'x-api-key'];
      for (const k of Object.keys(headers)) {
        if (SENSITIVE.includes(k.toLowerCase())) headers[k] = '[REDACTED]';
      }
      event.request.headers = headers;
    }
    if (event.user) {
      event.user = event.user.id ? { id: String(event.user.id) } : {};
    }
  } catch (_e) {
    /* never block telemetry */
  }
  return event;
}

let initialized = false;

export function initSentry() {
  if (initialized) return false;
  if (!DSN) {
    // Dormant — do not initialise. Log once so engineers know.
    // eslint-disable-next-line no-console
    console.info('[Sentry] DSN not configured — frontend error tracking dormant.');
    return false;
  }
  try {
    Sentry.init({
      dsn: DSN,
      environment: ENV,
      release: RELEASE,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: ENV === 'production' ? 0.2 : 1.0,
      sendDefaultPii: false,
      beforeSend,
    });
    initialized = true;
    // eslint-disable-next-line no-console
    console.info(`[Sentry] initialised env=${ENV} release=${RELEASE}`);
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[Sentry] init failed:', e);
    return false;
  }
}

export { Sentry };
